import React, { useState } from 'react';
import { Button } from '@material-ui/core';
import FullscreenIcon from '@material-ui/icons/Fullscreen';
import styled from 'styled-components';
import { modularScale } from '../../../../utils';
import Paginator from '../../../Paginator';
import ViewerErrorBoundary from '../common/ViewerConclusion/ViewerErrorBoundary';
import PDFDocument from './PDFDocument';
import PDFDownloadButton from './PDFDownloadButton';
import PDFModal from './PDFModal';
const PDFViewerContainer = styled.div `
    border: 1px solid ${(props) => props.theme.colors.border};
    border-radius: 4px;
`;
const PDFViewerDocument = styled.div `
    &:hover {
        cursor: pointer;
    }

    > div {
        display: flex;
        justify-content: center;
    }

    canvas {
        max-width: 100%;
    }

    .react-pdf__Page {
        overflow: hidden;
    }
`;
const PDFActionsContainer = styled.div `
    display: flex;
    padding: 0.5rem;
    color: ${(props) => props.theme.colors.primary};

    button {
        span {
            font-size: ${modularScale(-1)};
        }
    }
`;
const PDFViewer = ({ componentValues, DocumentComponent, PageComponent }) => {
    var _a;
    const [modalOpen, setModalOpen] = useState(false);
    const [totalPages, setTotalPages] = useState(0);
    const [page, setPage] = useState(1);
    const handleLoadSuccess = ({ numPages }) => {
        setTotalPages(numPages);
    };
    const onClose = (pageNumber) => {
        setModalOpen(false);
        setPage(pageNumber);
    };
    if (!DocumentComponent || !PageComponent || typeof window === 'undefined' || !((_a = componentValues === null || componentValues === void 0 ? void 0 : componentValues.pdf) === null || _a === void 0 ? void 0 : _a.url)) {
        return null;
    }
    return (React.createElement(ViewerErrorBoundary, null,
        React.createElement(PDFViewerContainer, null,
            React.createElement(PDFViewerDocument, { "data-testid": "PDFViewer-StyledPDF", onClick: (event) => {
                    if (event.target instanceof HTMLAnchorElement) {
                        return;
                    }
                    setModalOpen(true);
                } },
                React.createElement(PDFActionsContainer, null,
                    React.createElement(Button, { color: "primary", startIcon: React.createElement(FullscreenIcon, null), onClick: (event) => {
                            if (event.target instanceof HTMLAnchorElement) {
                                return;
                            }
                            setModalOpen(true);
                        } }, "Expand"),
                    React.createElement(PDFDownloadButton, { href: componentValues.pdf.url })),
                React.createElement(PDFDocument, { DocumentComponent: DocumentComponent, PageComponent: PageComponent, url: componentValues.pdf.url, handleLoadSuccess: handleLoadSuccess, page: page, setPage: setPage, totalPages: totalPages })),
            React.createElement(Paginator, { currentPage: page, totalPages: totalPages, onPreviousClick: () => setPage((prevPage) => prevPage - 1), onNextClick: () => setPage((prevPage) => prevPage + 1) })),
        React.createElement(PDFModal, { DocumentComponent: DocumentComponent, PageComponent: PageComponent, open: modalOpen, onClose: onClose, url: componentValues.pdf.url, totalPages: totalPages, initialPage: page })));
};
export default PDFViewer;
//# sourceMappingURL=index.js.map